import api from '../../services/api';

interface ExpenseResponse {
	id: string;
}

export interface ExpenseUserRequest {
	id: string;
	amount: number;
	currency: string;
}
export interface AddExpenseRequest {
	circleId: string;
	isSettlement: boolean;
	description: string;
	currency: string;
	amount: number;
	creditors: ExpenseUserRequest[];
	debtors: ExpenseUserRequest[];
	dateTime: Date;
}
export const addExpense = async (body: AddExpenseRequest): Promise<ExpenseResponse> => {
	return await api.post<ExpenseResponse>(`/api/expense`, body).then(res => res.data);
};

export const deleteExpense = async (id: string) => {
	await api.delete(`/api/expense/${id}`);
};

export interface UpdateExpenseRequest {
	id: string;
	isSettlement: boolean;
	description: string;
	currency: string;
	amount: number;
	creditors: ExpenseUserRequest[];
	debtors: ExpenseUserRequest[];
	dateTime: Date;
}

export const updateExpense = async (body: UpdateExpenseRequest) => {
	await api.put(`/api/expense/${body.id}`, body);
};
